import { useTranslation } from 'react-i18next';
import { Badge } from '@components/badge';
import { BADGE_VARIANT_GRAY, BADGE_VARIANT_YELLOW } from '@components/badge/badge.type';
import { IconEvents } from '@components/icons/icon-events';
import classNames from 'classnames';
import { Command } from 'cmdk';

import { MAGIC_SEARCH_ITEM_CLASS } from '../constants';
import { MagicSearchEventItemProps } from '../magic-search-palette.type';
import { formatResultDate } from '../utils/format-result-date';
import { getEventRoute } from '../utils/get-event-route';
import { isPastEvent } from '../utils/is-past-event';

import { MagicSearchItemMedia } from './magic-search-item-media';
import { MagicSearchItemText } from './magic-search-item-text';

export const MagicSearchEventItem = ({ event, onOpen }: MagicSearchEventItemProps) => {
  const { t, i18n } = useTranslation();
  const route = getEventRoute(event);
  const date = formatResultDate(event.startingTime, event.timezone, i18n.language);
  const isPast = event.isPublished && isPastEvent(event);

  return (
    <Command.Item
      value={`event:${event.id}`}
      disabled={!route}
      onSelect={() => route && onOpen(route)}
      className={classNames(MAGIC_SEARCH_ITEM_CLASS, { 'opacity-50': !route })}
      data-testid={`magic-search--result-event-${event.id}`}>
      <MagicSearchItemMedia Icon={IconEvents} imageUrl={event.coverUrl} />
      <MagicSearchItemText
        title={event.name ?? ''}
        legacyId={event.legacyId}
        lines={[[date, event.club?.name, event.company?.name], [route ? null : t('menu:magicSearchNotAvailable')]]}
      />
      <div className='flex shrink-0 gap-1'>
        {!event.isPublished && (
          <Badge variant={BADGE_VARIANT_YELLOW} dataTestId='magic-search-event--draft'>
            {t('menu:magicSearchDraft')}
          </Badge>
        )}
        {isPast && (
          <Badge variant={BADGE_VARIANT_GRAY} dataTestId='magic-search-event--past'>
            {t('menu:magicSearchPast')}
          </Badge>
        )}
        {event.isArchived && (
          <Badge variant={BADGE_VARIANT_GRAY} dataTestId='magic-search-event--archived'>
            {t('menu:magicSearchArchived')}
          </Badge>
        )}
      </div>
    </Command.Item>
  );
};
